import noImage from "assets/img/noImage.png";
import { correctUploadPath } from "core/utils/image-path-correction";
import React from "react";
import { useLocation } from "react-router-dom";
import "./LibraryDetail.scss";

const LibraryDetail = () => {
  const location = useLocation();
  const book = location.state?.book;

  if (!book) {
    return <div className="library-detail-notfound">کتابی یافت نشد</div>;
  }

  return (
    <div className="library-detail-wrapper">
      <div className="library-detail-image">
        <img
          src={
            book.imageThumbnail
              ? `${
                  process.env.REACT_APP_UPLOAD_SERVER_PATH
                }/${correctUploadPath(book.imageThumbnail)}`
              : noImage
          }
          alt={book.title}
        />
      </div>
      <div className="library-detail-info">
        <h1 className="book-title">{book.title}</h1>
        <p className="book-description">{book.description}</p>
        {book.files?.length > 0 && (
          <div className="download-action">
            <a
              href={`${
                process.env.REACT_APP_UPLOAD_SERVER_PATH
              }/${correctUploadPath(book.files[0])}`}
              download
              className="download-link"
            >
              دانلود فایل PDF
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export { LibraryDetail };
